export default __webpack_public_path__ + "static/media/Snowing_07.cbff4452.png";